import store from 'store';

const savedTempType = store.get('_weather-temp-type');

export const forecast = 'KSXX9999';
export const timezone = 'Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6';
export const useCelsius = savedTempType ? savedTempType === 'celsius' : /^edition\./.test(window.location.hostname);
export const apiBaseUrl = `//${/(www|edition|us).cnn.com/.test(window.location.hostname) ? 'data' : 'datadev'}.cnn.com/olympics/2018`;
export const hubPageUrl = '/specials/sport/winter-olympics-2018';

// Poll for new content every 30 seconds
export const dataRefreshTime = 30000;



// WEBPACK FOOTER //
// ./scripts/config.es6